var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{class:{ 'border-g-e8 bg-white': !_vm.active },attrs:{"input-value":_vm.active,"disabled":_vm.blocked,"filter":""},on:{"click":function($event){return _vm.setValue()}}},[_vm._v(_vm._s(_vm.$t(_vm.field.label)))])}
var staticRenderFns = []

export { render, staticRenderFns }